<template>
  <div class="delivery-card border border-1 rounded-2 w-100" @click="$emit('click')">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div class="card-body">
          <b-skeleton width="35%" height="20px" class="mb-2"></b-skeleton>
          <b-skeleton width="55%" height="24px" class="mb-2"></b-skeleton>
          <b-skeleton width="70%" height="20px"></b-skeleton>
        </div>
      </template>
      <p class="delivery-card__status">{{ $t(`delivery.status.${status.toLowerCase()}`) }}</p>
      <p class="delivery-card__amount">
        <span>{{ data?.count?.toLocaleString('en-US', { maximumFractionDigits: 2 }) ?? 0 }}</span>
        <span class="delivery-card__amount-text">
          {{ $tc('delivery.title.delivery', data?.count ?? 0) }}</span
        >
      </p>
      <div class="delivery-card__detail d-flex">
        <p class="delivery-card__data d-flex align-items-start gap-1 m-0">
          <i class="icon-outline_weight font-weight-semibold"></i>
          <span>
            {{ data?.weight?.value ?? 0 | formatNumber }}
            {{ data?.weight?.unit ?? 'Kg' }}
          </span>
        </p>
        <div class="delivery-card__data-divider mx-2"></div>
        <p class="delivery-card__data d-flex align-items-start gap-1 m-0">
          <i class="icon-outline_cube font-weight-semibold"></i>
          <span>
            {{ data?.volume?.value ?? 0 | formatNumber }} {{ data?.volume?.unit ?? 'Cbm' }}
          </span>
        </p>
      </div>
      <i
        :class="['delivery-card__icon', 'rounded-circle', icon.variant]"
        :style="{ color: icon.color, backgroundColor: icon.backgroundColor }"
      ></i>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import { deliveryStatusKeys } from '../lib/constants/delivery-status-keys'

export default {
  props: {
    status: {
      required: true,
      type: String,
    },
    data: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    icon() {
      return deliveryStatusKeys[this.status]?.icon ?? {}
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin large-screen {
  @media screen and (min-width: 992px) and (max-width: 1200px) {
    @content;
  }
}

.delivery-card {
  position: relative;
  padding: 12px;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 5px 15px 0px rgba(13, 68, 145, 0.08);
  }

  &__status {
    margin-bottom: 16px;
    font-weight: 600;
    color: $mep-color-text;
  }

  &__amount {
    font-size: 12px;
    font-weight: 600;

    span {
      color: $mep-color-text-400;
      font-size: 20px;
    }
  }

  &__amount-text {
    color: $mep-color-text-400;
    font-size: 12px !important;
    font-weight: 500;
  }

  &__detail {
    align-items: center;
    color: $mep-color-text;

    @include large-screen() {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__data {
    line-height: normal;

    &-divider {
      width: 1px;
      height: 20px;
      background: #cfdae9;

      @include large-screen() {
        display: none;
      }
    }
  }

  &__icon {
    position: absolute;
    right: 12px;
    top: 12px;
    font-size: 20px;
    padding: 6px;
  }
}
</style>
